'use client';

import React from 'react';
import { Hand, ScanSearch, ZoomIn, ZoomOut, RotateCcw } from 'lucide-react';

interface Props {
  dragMode: 'pan' | 'zoom';
  onSetDragMode: (mode: 'pan' | 'zoom') => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetView: () => void;
}

const ToolBtn: React.FC<{
  onClick: () => void;
  active?: boolean;
  label: string;
  children: React.ReactNode;
}> = ({ onClick, active, label, children }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    aria-pressed={active}
    className={`p-[10px] rounded-sm transition-colors border ${
      active
        ? 'text-accent bg-accent-dim border-accent'
        : 'text-text-muted border-transparent hover:text-text-secondary hover:bg-bg-raised'
    }`}
  >
    {children}
  </button>
);

export const MapToolbar: React.FC<Props> = ({
  dragMode, onSetDragMode, onZoomIn, onZoomOut, onResetView,
}) => (
  <div
    className="absolute right-3 top-1/2 -translate-y-1/2 z-[50] hidden desk:flex flex-col gap-[3px] p-[4px] rounded-sm border border-border"
    style={{ backgroundColor: 'var(--bg-panel)' }}
  >
    <ToolBtn onClick={() => onSetDragMode('zoom')} active={dragMode === 'zoom'} label="Zoom box">
      <ScanSearch size={17} aria-hidden="true" />
    </ToolBtn>
    <ToolBtn onClick={() => onSetDragMode('pan')} active={dragMode === 'pan'} label="Pan">
      <Hand size={17} aria-hidden="true" />
    </ToolBtn>
    <div className="h-px bg-border mx-[4px] my-[3px]" aria-hidden="true" />
    <ToolBtn onClick={onZoomIn} label="Zoom in">
      <ZoomIn size={17} aria-hidden="true" />
    </ToolBtn>
    <ToolBtn onClick={onZoomOut} label="Zoom out">
      <ZoomOut size={17} aria-hidden="true" />
    </ToolBtn>
    <div className="h-px bg-border mx-[4px] my-[3px]" aria-hidden="true" />
    <ToolBtn onClick={onResetView} label="Reset view">
      <RotateCcw size={17} aria-hidden="true" />
    </ToolBtn>
  </div>
);
